import React, { useContext } from 'react';
import { Tab, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import StoriaClinica from './StoriaClinica';
import StoriaFamiliare from './StoriaFamiliare';
import Allergie from '../Common/Allergie';
import PrecedentiEsami from '../Common/PrecedentiEsami';
import TextAreaFse from '../TextAreaFse';
import Complicanze from './Complicanze';
import { RefertoContext } from 'app/context/RefertoContext';
import {
    complicanzeModified,
    informazioniAggiuntiveModified,
    storiaClinicaModified,
    storiaFamiliareModified
} from 'app/views/app/Editor/GestioneOggettiRad';
import GrigliaDiagnosi from '../../Accettazione/GrigliaDiagnosi';
import {
    conclusioniModified,
    esamiPrecedentiModified,
    suggerimentiModified,
    allergieModified,
    diagnosiModified
} from 'app/views/app/Editor/GestioneOggetticomuni';

const SezioniRad = ({ soloDiagnosi = false }) => {

    const { state: referto, dispatch: dispatchReferto } = useContext(RefertoContext);
    const abilitaStFam = storiaClinicaModified(referto.storiaClinica);

    const handleSetConclusioni = (val) => {
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "conclusioni",
            payload: val
        });
    };

    const handleSetInformazioniAggiuntive = (val) => {
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "informazioniAggiuntive",
            payload: val
        });
    };
    const handleSetsuggerimentoMedico = (val) => {
        dispatchReferto({
            type: "UPDATE_FIELD",
            field: "suggerimentiMedico",
            payload: val
        });
    };

    const options = [
        {
            label: "Quesito Diagnostico",
            eventKey: "quesito",
            completed: diagnosiModified(referto.diagnosi),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <GrigliaDiagnosi />
        },
        {
            label: "Storia Clinica",
            eventKey: "storiaClinica",
            completed: storiaClinicaModified(referto.storiaClinica),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <StoriaClinica />
        },

        {
            label: "Storia Familiare",
            eventKey: "storiaFamiliare",
            completed: storiaFamiliareModified(referto.storiaFamiliare),
            disabled: !abilitaStFam,
            tooltip: !abilitaStFam ? "Compilare la sezione STORIA CLINICA prima" : "Sezione Opzionale",
            component: <StoriaFamiliare />
        },
        {
            label: "Allergie",
            eventKey: "allergie",
            completed: allergieModified(referto.allergie),
            disabled: !abilitaStFam,
            tooltip: !abilitaStFam ? "Compilare la sezione STORIA CLINICA prima" : "Sezione Opzionale",
            component: <Allergie />
        },
        {
            label: "Precedenti Esami Eseguiti",
            eventKey: "precedentiEsami",
            completed: esamiPrecedentiModified(referto.prec),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <PrecedentiEsami />
        },
        {
            label: "Conclusioni",
            eventKey: "conclusioni",
            completed: conclusioniModified(referto.conclusioni),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <TextAreaFse
                value={referto.conclusioni}
                setValue={handleSetConclusioni}
                title="Conclusioni"
            />
        },
        {
            label: "Informazioni Aggiuntive",
            eventKey: "informazioniAggiuntive",
            completed: informazioniAggiuntiveModified(referto.informazioniAggiuntive),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <TextAreaFse
                value={referto.informazioniAggiuntive}
                setValue={handleSetInformazioniAggiuntive}
                title="Informazioni Aggiuntive"
            />
        },

        {
            label: "Complicanze",
            eventKey: "complicanze",
            completed: complicanzeModified(referto.complicanze),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <Complicanze
                complicanze={referto.complicanze}
            />
        },

        {
            label: "Suggerimenti Medico",
            eventKey: "suggerimentiMedico",
            completed: suggerimentiModified(referto.suggerimentiMedico),
            disabled: false,
            tooltip: "Sezione Opzionale",
            component: <TextAreaFse
                value={referto.suggerimentiMedico}
                setValue={handleSetsuggerimentoMedico}
                title="Suggerimenti Medico Prescrittore"
            />
        },

    ];


    // Filtro se soloDiagnosi=true
    const filteredOptions = soloDiagnosi
        ? options.filter(opt => opt.eventKey === "quesito")
        : options;

    // Primo tab attivo
    const defaultActiveKey =
        filteredOptions.find(opt => !opt.disabled)?.eventKey ||
        filteredOptions[0].eventKey;

    return (
        <div className="container-fluid">
            <Tab.Container id="sezioni-rad-tabs" defaultActiveKey={defaultActiveKey}>
                <div className="row">
                    {!soloDiagnosi && (
                        <div className="col-md-3">
                            <Nav variant="pills" className="d-flex flex-column">
                                {filteredOptions.map((option, idx) => (
                                    <Nav.Item key={option.eventKey}>
                                        <OverlayTrigger
                                            placement="right"
                                            delay={{ show: 250, hide: 0 }}
                                            overlay={
                                                <Tooltip>
                                                    {option.completed ? "Compilata" : option.tooltip}
                                                </Tooltip>
                                            }
                                        >
                                            <span
                                                className="d-inline-block"
                                                style={{
                                                    width: "100%",
                                                    cursor: option.disabled ? "not-allowed" : undefined
                                                }}
                                            >
                                                <Nav.Link
                                                    eventKey={option.eventKey}
                                                    className={option.completed ? "fw-bold" : ""}
                                                    style={option.disabled ? { opacity: 0.65, pointerEvents: "none" } : {}}
                                                >
                                                    {`${idx + 1} - ${option.label}`}
                                                    {option.completed && (
                                                        <i className="mx-2 i-Paper-Plane text-success fw-bolder" />
                                                    )}
                                                </Nav.Link>
                                            </span>
                                        </OverlayTrigger>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </div>
                    )}

                    <div className={soloDiagnosi ? "col-12" : "col-md-9"}>
                        <Tab.Content className="p-0">
                            {filteredOptions.map(option => (
                                <Tab.Pane eventKey={option.eventKey} key={option.eventKey}>
                                    <h3 className="text-center mb-4">{option.label}</h3>
                                    {option.component}
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </div>

                </div>
            </Tab.Container>
        </div>
    );
};

export default SezioniRad;
